import { Link } from "react-router-dom";
import { CheckIcon } from "../pricing/constants";
import { why_constants } from "./constants";

export default function Why() {
  return (
    <section className="py-10 bg-white">
      <div className="container  px-3">
        <div className="space-y-[24px] md:space-y-[48px]">
          {why_constants.map((r, i) => (
            <div className="grid sm:grid-cols-2 gap-14" key={r.title}>
              <div
                className={`space-y-[18px] ${
                  i % 2 ? "md:order-last" : "md:order-first"
                }`}
              >
                <h3 className="text-[20px] lg:text-[32px] font-bold text-black ">
                  {r.title}
                </h3>

                <div className="space-y-3">
                  {r.features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <CheckIcon />
                      <span className="text-[#222] text-sm">{feature}</span>
                    </div>
                  ))}
                </div>

                <Link
                  to={r.ctaLink}
                  className="rounded-lg bg-primary_alt border border-[#B6E4FF] py-2.5 px-4 text-white text-center hover:text-white/80 w-max inline-block"
                >
                  {r.cta}
                </Link>
              </div>

              <div
                className={`rounded-[12px] ${
                  i % 2 ? "md:order-first" : "md:order-last"
                }`}
              >
                <img src={r.image} alt={r.title} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
